@use '@lib/assets/styles/main.scss' as *;

.title {
  margin-top: 24px;
  margin-bottom: 8px;
}
